import { mapState } from 'vuex';
import { cloudFunctions, webPushId } from '../config';
import { db } from '../db';

export default {
  name: 'push-notifications-mixin',

  computed: {
    ...mapState([
      'user_data',
      'userType',
      'bindedUserData',
      'askForPushPermition',
    ]),
  },

  methods: {
    updateUserAccount(data) {
      db.collection(this.userType)
        .doc(this.user_data.id)
        .update(data);
    },

    checkSafariPushNoifications(val = null) {
      if ('safari' in window && 'pushNotification' in window.safari) {
        console.log('debug: safari & pushNotifications exists in window');
        const permissionData = window.safari.pushNotification.permission(webPushId);
        this.checkRemotePermission(permissionData, val);
      } else {
        console.log('not safari or permission denied');
      }
    },

    checkRemotePermission(permissionData, val) {
      console.log({ permissionData });
      if (permissionData.permission === 'default') {
        console.log(`${this.timeStamp()}Permission is default (first time)`);
        this.$store.state.askForPushPermition = true;
      } else if (permissionData.permission === 'denied') {
        console.log(`${this.timeStamp()}Permission is denied`);
        this.$store.state.pushNotificationsAllowedInBrowser = false;

        this.updateUserAccount({
          messagingPush: false,
          messagingPushChat: false,
          messagingPushMatch: false,
          messagingPushConnection: false,
        });

        if (val) {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Um Push-Message zu aktivieren, gehe bitte in die Einstellungen deines Browsers.',
          });
        }
      } else if (permissionData.permission === 'granted') {
        console.log(`${this.timeStamp()}User device token is: ${permissionData.deviceToken}`);
        this.sendTokenToServer(permissionData.deviceToken, 'safari', true);
      }
    },

    requestSafariPersission() {
      console.log('debug: call request safari permission');
      window.safari.pushNotification.requestPermission(
        cloudFunctions, // The web service URL.
        webPushId, // The Website Push ID.
        {
          userType: this.userType,
          userId: this.user_data.id,
        }, // Data that you choose to send to your server to help you identify the user.
        this.checkRemotePermission, // The callback function.
      );
    },

    timeStamp() {
      const now = new Date();
      const time = [now.getHours(), now.getMinutes(), now.getSeconds()];

      for (let i = 1; i < 3; i++) {
        if (time[i] < 10) {
          time[i] = `0${time[i]}`;
        }
      }

      return `<i>${time.join(':')}</i> `;
    },

    messagingInit() {
      this.$messaging.onTokenRefresh(() => {
        this.$messaging.getToken().then((refreshedToken) => {
          console.log('Token refreshed.');
          this.setTokenSentToServer(false);
          this.sendTokenToServer(refreshedToken);
        });
      });
    },
    messagingRegister(val = null) {
      return this.$messaging.requestPermission().then(() => {
        console.log('Notification permission granted.');
        this.messagingGetToken();
      }).catch((err) => {
        console.log('Unable to get permission to notify.', err);
        this.$store.state.pushNotificationsAllowedInBrowser = false;

        this.updateUserAccount({
          messagingPush: false,
          messagingPushChat: false,
          messagingPushMatch: false,
          messagingPushConnection: false,
        });

        if (val) {
          this.$store.commit({
            type: 'openSnackbar',
            text: 'Um Push-Message zu aktivieren, gehe bitte in die Einstellungen deines Browsers.',
          });
        }
        return false;
      });
    },
    messagingGetToken() {
      // if (!this.user_data.messagingToken) {
      this.$messaging.getToken().then((currentToken) => {
        if (currentToken) {
          this.sendTokenToServer(currentToken);
        } else {
          console.log('No Instance ID token available. Request permission to generate one.');
          // Show permission UI.
          this.setTokenSentToServer(false);
        }
      }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
        this.setTokenSentToServer(false);
      });
      // }
    },
    async sendTokenToServer(token, type = null) {
      console.log({ token });

      const data = {
        messagingToken: null,
        safariToken: null,
        messagingPush: true,
      };

      if (type === 'safari') {
        data.safariToken = token;
      } else {
        data.messagingToken = token;
      }

      await this.setDefaultMessagingSettings(this.user_data, data, true);
    },

    setTokenSentToServer(type) {
      // always leave token, to send or not will be checked on messagingPushXXXX variables in userData
      // if (type) return;

      // db.collection(this.userType)
      //   .doc(this.user_data.id)
      //   .update({
      //     messagingToken: null,
      //     safariToken: null,
      //   });
    },

    async setDefaultMessagingSettings(userData, pushSettings = null, pushAllowed = false) {
      let defaultMessagingSettings = {};
      if (userData.messagingEmailChat === undefined) {
        defaultMessagingSettings.messagingEmailChat = true;
      }
      if (userData.messagingEmailMatch === undefined) {
        defaultMessagingSettings.messagingEmailMatch = true;
      }
      if (userData.messagingEmailConnection === undefined) {
        defaultMessagingSettings.messagingEmailConnection = true;
      }

      if (pushAllowed) {
        defaultMessagingSettings.messagingPushChat = true;
        defaultMessagingSettings.messagingPushMatch = true;
        defaultMessagingSettings.messagingPushConnection = true;
      }

      console.log('setDefaultMessaging', { userData });

      if (pushSettings) {
        defaultMessagingSettings = {
          ...defaultMessagingSettings,
          ...pushSettings,
        };
      }

      if (JSON.stringify(defaultMessagingSettings) !== '{}') {
        await db.collection(this.userType)
          .doc(this.user_data.id)
          .update(defaultMessagingSettings);
      }
    },

    iOS() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod',
      ].includes(navigator.platform)
        // iPad on iOS 13 detection
        || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    },
  },
};
